import { defineMessages } from 'react-intl'

/* eslint-disable max-len */
export default defineMessages({
  heroTitle: 'Automated sales processes',
  name: 'Business Case',
  heroDescription: 'How long does it take your sales team to be able to send an individual offer after a customer enquiry? This process is often more complex and time-consuming than you think. We support your sales department by integrating individual product configurators into your existing system landscape and connecting them. This allows your employees to easily and specifically "click together" the required products and desired properties and create an automated offer if required.'
})
